import { render, staticRenderFns } from "./diyGrid.vue?vue&type=template&id=04c0fbb2&scoped=true&"
import script from "./diyGrid.vue?vue&type=script&lang=js&"
export * from "./diyGrid.vue?vue&type=script&lang=js&"
import style0 from "./diyGrid.vue?vue&type=style&index=0&id=04c0fbb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c0fbb2",
  null
  
)

export default component.exports